export default __webpack_public_path__ + "d661cc03ad8ff3a10918915b06f6cb2b.svg";